import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Box,
  TextField,
  Button,
  Icon,
  Snackbar,
  Grid,
  Divider,
  Avatar,
  Typography,
  LinearProgress,
  Chip,
  Tabs,
  Tab,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import { apiUrl, updateHeight, appendStyle, mobileCheck, getParam } from "../common";
import MuiAlert from "@material-ui/lab/Alert";
import * as moment from "moment";
import { Base64 } from "js-base64";
import ImageUploader from "react-images-upload";
//LightGallery
import LightGallery from "lightgallery/react";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";

import PoweredBy from "../powered-by";
import "./index.css";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import queryString from "query-string";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" value={props.value} />
      </Box>
      <Box minWidth={35}>
        <Typography
          variant="body2"
          style={{ fontWeight: "bold", color: props.color }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  form: {
    //maxWidth: 396,
    margin: "0 auto",
    //boxShadow: "0 10px 24px 0 rgba(54, 61, 77, 0.15)",
    border: "1px solid #d9d9d9",
    backgroundColor: "#fff",
    color: "#333",
    fontSize: 13,
  },
  name: {
    fontWeight: "bold",
  },
  avgStar: {
    fontSize: 24,
    fontWeight: "bold",
  },
  title2: {
    fontSize: 14,
    fontWeight: "bold",
  },
  chip: {
    marginTop: "8px",
    marginRight: "6px",
  },
  button: {
    // "&:hover": {
    //   "box-shadow": "0 0 6px silver",
    // },
    //backgroundColor: "#ffb400",
    //color: "#fff",
  },
  selected: {
    border: "1px solid #3f51b5",
  },
  dark: {
    color: "#333",
    borderColor: "#333",
  },
  light: {
    color: "#fff",
    borderColor: "#fff",
  },
  reply: {
    backgroundColor: "#f2f2f2",
    borderLeft: "6px solid #ddd",
  },
}));
const defaultColor = "#ffb400";

const ProductReviews = (props) => {
  const classes = useStyles();
  const model = props.model;
  const { id, wid } = useParams();

  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const [hover, setHover] = useState(-1);
  const [data, setData] = useState();
  const [config, setConfig] = useState({
    hideTime: true,
    starColor: defaultColor,
    buttonColor: defaultColor,
  });
  const [reviewType, setReviewType] = React.useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [rating, setRating] = useState(0);
  const [defaultValue, setDefaultValue] = useState({
    name: "",
    phone: "",
    email: "",
    rating: 5,
    title: "",
    content: "",
  });
  const messageType = "product-reviews";
  const [pictures, setPictures] = useState([]);
  const { t } = useTranslation();

  const validationSchema = yup.object().shape({
    name: yup.string().required(t("Label.Required")),
    phone: yup
      .string()
      .min(10, t("Label.DataInvalid"))
      .max(12, t("Label.DataInvalid"))
      .required(t("Label.Required")),
    email: yup.string().email(t("Label.DataInvalid")),
    title: yup.string().required(t("Label.Required")),
    content: yup.string().required(t("Label.Required")),
  });

  const labels = [
    { rating: 1, name: t("Label.VeryBad") },
    { rating: 2, name: t("Label.Bad") },
    { rating: 3, name: t("Label.Normal") },
    { rating: 4, name: t("Label.Good") },
    { rating: 5, name: t("Label.VeryGood") },
  ];
  const isMobile = mobileCheck();
  const chips = isMobile
    ? []
    : [
      t("Label.GoodProductQuality"),
      t("Label.GoodProductPack"),
      t("Label.GoodStoreService"),
      t("Label.GoodWorthMoney"),
      t("Label.GoodDeliveryTime"),
    ];

  const onDrop = (picture) => {
    setPictures(picture);
  };
  useEffect(() => {
    const params = queryString.parse(window.location.search);
    if (params.lng) {
      i18n.changeLanguage(
        params.lng === "vi_VN" || params.lng === "ko_KR" ? params.lng : "en_US"
      );
    }
    if (params.data) {
      try {
        //console.log(Base64.encodeURI(JSON.stringify({ name: 'Hoàng Cường', phone: '0988999222' })));
        //eyJuYW1lIjoiSG_DoG5nIEPGsOG7nW5nIiwicGhvbmUiOiIwOTg4OTk5MjIyIn0
        const data = JSON.parse(Base64.decode(params.data));
        setDefaultValue({
          ...data,
          rating: 5,
          title: "",
          content: "",
        });
      } catch (error) { }

    }
    if (count == 0) {
      window.addEventListener("message", (event) => {
        //console.log(event.data);
        //if (event.origin === window.origin) return;

        let data = event.data;
        if (data.type !== messageType) return;

        if (data.key === "setData") {
          let objJson = JSON.parse(Base64.decode(data.value));
          //console.log(objJson.data);
          setData(objJson.data);
          //loadReview();
        } else if (data.key === "setConfig") {
          //console.log('setConfig', data.value);
          setConfig(data.value);
          appendStyle(
            "MuiLinearProgress-bar",
            ".MuiLinearProgress-bar{background-color:" +
            data.value.starColor +
            "!important}"
          );
        }
      });
    }
    //var device = JSON.parse(localStorage.getItem("device"));//device.os.name.toLowerCase() === "ios"
    //console.log(device);
    if ((id && wid) || count > 0) {
      loadReview();
    }

    setCount(count + 1);
    updateHeight(messageType);
  }, [pageIndex, rating, reviewType]);

  const loadReview = () => {
    //1234/60d2e58d1268d323f5adbaa1
    var hasParam = wid && id && !data?.productReviewExt ? true : false;
    fetch(`${apiUrl}/api/ProductReview/GetData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        WebsiteId: wid ?? data.productReviewExt.websiteId,
        ProductId: id ?? data.productReviewExt.productId,
        Type: reviewType,
        Rating: rating,
        HasParam: hasParam,
        Page: pageIndex,
        Limit: mobileCheck() ? 3 : 5,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (res.success) {
          //console.log(res.data);
          let newData = { ...data };
          newData.paginatedList = res.data.paginatedList;
          if (res.data.productReviewExt)
            newData.productReviewExt = res.data.productReviewExt;
          setData(newData);
          if (res.data.config) setConfig(res.data.config);
          //console.log(newData);
          //updateHeight(messageType);
        }
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValue,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm, setFieldError }) => {
      if (isNaN(values.phone)) {
        setFieldError("phone", t("Label.DataInvalid"));
        return;
      }
      //console.log(values);
      let param = {
        ...values,
        type: reviewType,
        productId: id ?? data.productReviewExt.productId,
        websiteId: wid ?? data.productReviewExt.websiteId,
        uid: model?.parent?.uid ?? "",
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(param));
      pictures.forEach((item) => {
        formData.append("formFiles", item);
      });
      fetch(`${apiUrl}/api/ProductReview`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.success) {
            setOpen(true);
            resetForm();
            setPictures([]);
            setTimeout(() => {
              setOpen(false);
              setOpenReview(false);
              updateHeight(messageType);
            }, 2000);
          }
        });
    },
  });

  const [images, setImages] = useState([]);
  const lightGallery = useRef(null);

  const onInit = useCallback((detail) => {
    if (detail) {
      lightGallery.current = detail.instance;
    }
  }, []);

  const clickImage = (item, index) => {
    let newImages = item.images.map((img, idx) => {
      return {
        id: idx + 1,
        src: img,
        thumb: img,
        subHtml: `<div class="lightGallery-captions">
              <h4>${item.name}: ${item.title}</h4>
              <p>${item.content}</p>
          </div>`,
      };
    });
    setImages(newImages);
    lightGallery.current.refresh(newImages);
    lightGallery.current.openGallery(index);
  };

  const toggleLG = () => {
    window.parent.postMessage(
      {
        type: messageType,
        key: "toggle-lg",
        value: {},
      },
      "*"
    );
  };

  const handleChangeReviewType = (event, newValue) => {
    setReviewType(newValue);
  };
  //console.log(formik.errors);
  //console.log(labels);
  return (
    <Box
      className={classes.form}
      style={{
        position: "relative",
        //padding: model.size == "normal" ? 48 : 32,
      }}
      p={2}
    >
      <Box mb={2}>
        <Box className={classes.title}>{t("Label.ReviewsTitle")}</Box>
        <Grid container spacing={2}>
          {(!isMobile || !openReview) && (
            <Grid item xs={12} sm={5}>
              <Box>
                <Box display="flex" alignItems="center">
                  <Typography
                    className={classes.avgStar}
                    style={{
                      color: config.starColor,
                      fontSize: 30,
                    }}
                  >
                    {data && data.productReviewExt.countRating > 0
                      ? `${data.productReviewExt.averageRating}/5`
                      : ""}
                  </Typography>
                  <Box mx={2}>
                    <Rating
                      name="avgStar"
                      precision={0.5}
                      value={data ? data.productReviewExt.averageRating : 0}
                      style={{
                        color: config.starColor,
                        fontSize: 30,
                      }}
                      readOnly
                    />
                  </Box>
                  <Typography>
                    {data ? `(${data.productReviewExt.countRating} ${t("Label.Reviews")})` : ""}
                  </Typography>
                </Box>
                <Box display="flex" flexDirection="column-reverse">
                  {labels
                    .sort((a, b) => (a.rating > b.rating ? 1 : -1))
                    .map((item, index) => (
                      <Box key={index} display="flex" alignItems="center">
                        <Typography>{item.rating}</Typography>
                        <Box mr={1}>
                          <Icon
                            fontSize={"small"}
                            style={{
                              color: config.starColor,
                            }}
                          >
                            star
                          </Icon>
                        </Box>
                        <Box minWidth={220}>
                          <LinearProgressWithLabel
                            value={
                              data && data.productReviewExt.countRating > 0
                                ? (data.productReviewExt[
                                  `rating${item.rating}`
                                ] *
                                  100) /
                                data.productReviewExt.countRating
                                : 0
                            }
                            color={config.starColor}
                          />
                        </Box>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Grid>
          )}
          <Grid item xs={12} sm={7}>
            <Box display={"flex"} flexDirection={"column"}>
              {!isMobile && data?.paginatedList.results.filter(x => x.images)?.length > 0 &&
                <Box display={"flex"} flexDirection={"column"} alignItems={"end"} mb={1}>
                  <Box className={classes.title2} mb={1}>{t("Label.Image")}</Box>
                  <Box display={"flex"} flexWrap="wrap" alignItems="center">
                    {data?.paginatedList.results.filter(x => x.images).map((item, index) => (
                      <Box
                        key={`box-img-${index}`}
                        ml={1}
                        style={{
                          width: "90px",
                          height: "90px",
                          cursor: "pointer",
                          borderRadius: "5px",
                          backgroundImage: `url(${item.images[0]})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                        }}
                        onClick={() => {
                          clickImage(item, 0);
                        }}
                      ></Box>
                    ))}
                  </Box></Box>}
              <Box
                display="flex"
                flexDirection="row-reverse"
                alignItems="flex-end"
              >
                <Box textAlign="right" ml={2}>
                  <Button
                    variant="outlined"
                    startIcon={<Icon>comment</Icon>}
                    onClick={() => {
                      if (config.requiredLogin) {
                        alert(t("Label.RequiredLogin"));
                        return;
                      }
                      setOpenReview(!openReview);
                      updateHeight(messageType);
                    }}
                    className={openReview ? classes.selected : ""}
                  >
                    {t(
                      reviewType === 0
                        ? "Label.WriteReviews"
                        : "Label.WriteQuestion"
                    )}
                  </Button>
                </Box>
                {data?.productReviewExt.countRating > 0 && reviewType === 0 && (
                  <FormControl style={{ minWidth: 120 }}>
                    <InputLabel>{t("Label.Rating")}</InputLabel>
                    <Select
                      value={rating}
                      onChange={(event) => {
                        setRating(event.target.value);
                        setPageIndex(1);
                      }}
                    >
                      <MenuItem value={0}>{t("Label.All")}</MenuItem>
                      {labels
                        .sort((a, b) => (a.rating > b.rating ? -1 : 1))
                        .map((item, index) => (
                          <MenuItem key={index} value={item.rating}>
                            {`${item.rating} ⭐ (${data.productReviewExt[`rating${item.rating}`]
                              })`}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {openReview && (
        <Box>
          <Box mb={2}>
            <Divider />
          </Box>
          <form onSubmit={formik.handleSubmit} noValidate>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    required
                    variant="outlined"
                    size="small"
                    name="name"
                    label={t("Label.FullName")}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    required
                    variant="outlined"
                    size="small"
                    name="phone"
                    label={t("Label.Phone")}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.phone}
                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                    helperText={formik.touched.phone && formik.errors.phone}
                  />
                </Grid>
                {!isMobile && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="email"
                      label={t("Label.Email")}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
            {reviewType === 0 && (
              <Box mt={2} display="flex" alignItems="center">
                <Box mr={1}>{t("Label.Reviews")}</Box>
                <Rating
                  size="small"
                  name="rating"
                  style={{
                    color: config.starColor,
                  }}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  value={parseInt(formik.values.rating)}
                />
                {/* {formik.values.rating !== null && (
                  <Box ml={1}>
                    {
                      labels[
                        (hover !== -1
                          ? hover
                          : parseInt(formik.values.rating)) - 1
                      ].name
                    }
                  </Box>
                )} */}
              </Box>
            )}
            <Box mt={2}>
              <TextField
                fullWidth
                required
                variant="outlined"
                size="small"
                name="title"
                label={t("Label.Title")}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.title}
                error={formik.touched.title && Boolean(formik.errors.title)}
                helperText={formik.touched.title && formik.errors.title}
              />
            </Box>
            {reviewType === 0 && (
              <Box>
                {chips.map((chip, index) => (
                  <Chip
                    key={`chip-${index}`}
                    className={`${classes.chip} ${formik.values.title.includes(chip) ? classes.selected : ""
                      }`}
                    label={chip}
                    clickable
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      if (!formik.values.title.includes(chip)) {
                        //let newTitle = formik.values.title + `${chip} `;
                        formik.setFieldValue("title", chip);
                      }
                    }}
                  />
                ))}
              </Box>
            )}
            <Box mt={2}>
              <TextField
                fullWidth
                required
                variant="outlined"
                size="small"
                multiline
                rows={isMobile ? 2 : 3}
                name="content"
                label={t("Label.Content")}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.content}
                error={formik.touched.content && Boolean(formik.errors.content)}
                helperText={formik.touched.content && formik.errors.content}
              />
            </Box>
            {reviewType === 0 && (
              <Box>
                {chips.map((chip, index) => (
                  <Chip
                    key={`chip-${index}`}
                    className={`${classes.chip} ${formik.values.content.includes(chip)
                      ? classes.selected
                      : ""
                      }`}
                    label={chip}
                    clickable
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      let newContent = formik.values.content;
                      if (!formik.values.content.includes(chip)) {
                        newContent = formik.values.content + `${chip} `;
                      } else newContent = newContent.replace(`${chip} `, "");
                      formik.setFieldValue("content", newContent);
                    }}
                  />
                ))}
              </Box>
            )}
            {reviewType === 0 && (
              <Box mt={2}>
                <Box>{t("Label.Image")}</Box>
                <ImageUploader
                  buttonText={t("Label.ImageSelect")}
                  label={t("Label.ImageHelper")}
                  fileSizeError={t("Label.ImageSizeBig")}
                  fileTypeError={t("Label.ImageTypeNotSupport")}
                  withIcon={false}
                  withPreview={true}
                  onChange={onDrop}
                  imgExtension={[".jpg", ".jpeg", ".png", ".gif"]}
                  maxFileSize={5242880}
                />
              </Box>
            )}
            <Box mt={2} textAlign="right">
              <Button
                variant="outlined"
                type="submit"
                startIcon={<Icon>send</Icon>}
                className={classes.button}
                style={{
                  //borderRadius: model.variant == "standard" ? 0 : 4,
                  backgroundColor: config.buttonColor,
                  color: "#fff",
                }}
              >
                {t("Label.SendReviews")}
              </Button>
            </Box>
          </form>
        </Box>
      )}
      <Box mt={2}>
        <Divider />
      </Box>
      <Tabs
        value={reviewType}
        onChange={handleChangeReviewType}
        // variant="fullWidth"
        indicatorColor="primary"
      // textColor="primary"
      >
        {/* <Tab icon={<Icon>star</Icon>} label="Reviews" /> */}
        <Tab label={t("Label.Reviews")} />
        <Tab label={t("Label.QA")} />
      </Tabs>
      <Box my={1}>
        {/* {data?.paginatedList.totalPages > 1 && (
          <Box display="flex" justifyContent="flex-end">
            <Pagination
              count={data.paginatedList.totalPages}
              variant="outlined"
              shape="rounded"
              size="small"
              page={pageIndex}
              onChange={(event, page) => {
                setPageIndex(page);
              }}
            />
          </Box>
        )} */}
        {data?.paginatedList.results.map((item, index) => (
          <Box key={index} py={1}>
            <Box display="flex" alignItems="center">
              {
                data?.productReviewExt?.websiteId !== "641974377e722e569655df8a" &&
                <Box mr={1}>
                  <Avatar>{item.name.substring(0, 1)}</Avatar>
                </Box>
              }
              <Box>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Box display="flex" flexDirection="column">
                    <Box className={classes.name}>{item.name}</Box>
                    {reviewType === 0 && (
                      <Box>
                        <Rating
                          size="small"
                          name={"rating" + index}
                          style={{
                            color: config.starColor,
                            fontSize: "16px"
                          }}
                          value={item.rating}
                          readOnly
                        />
                      </Box>
                    )}
                  </Box>
                  {(item.purchased || config.purchased) && reviewType === 0 && (
                    <Box mx={1}>
                      <Chip
                        style={{
                          color: "#28a745",
                          borderColor: "#28a745",
                        }}
                        icon={
                          <Icon style={{ width: "1em", height: "1em" }}>
                            check_circle
                          </Icon>
                        }
                        label={t("Label.Purchased")}
                        color="primary"
                        variant="outlined"
                        size="small"
                      />
                    </Box>
                  )}

                </Box>
              </Box>

            </Box>
            <Box py={1}>
              <Box className={classes.title2}>{item.title}</Box>
              <Box my={1}>{item.content}</Box>
              <Box my={1}>
                {item.images && (
                  <Box display={"flex"} flexWrap="wrap" alignItems="center">
                    {item.images.map((link, index) => (
                      <Box
                        key={`img-${index}`}
                        mr={1}
                        style={{
                          width: "80px",
                          height: "80px",
                          cursor: "pointer",
                          borderRadius: "4px",
                          backgroundImage: `url(${link})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                        }}
                        onClick={() => {
                          clickImage(item, index);
                        }}
                      ></Box>
                    ))}
                  </Box>
                )}
              </Box>
              {!config.hideTime && <Box>{moment(item.createdAt).format("DD-MM-YYYY HH:mm")}</Box>}
            </Box>
            {item.replyContent && (
              <Box py={1} px={2} className={classes.reply}>
                <Box
                  display={"flex"}
                  alignItems="center"
                  className={classes.name}
                >
                  {config.avatarUrl && (
                    <Avatar alt={config.replyName} src={config.avatarUrl} />
                  )}
                  {!config.avatarUrl && (
                    <Avatar>
                      <Icon>account_circle</Icon>
                    </Avatar>
                  )}
                  <Box ml={1}>{config.replyName}</Box>
                </Box>
                <Box my={1}>{item.replyContent}</Box>
                {/* <Box>{moment(item.replyAt).format("DD-MM-YYYY HH:mm")}</Box> */}
              </Box>
            )}
            <Divider />
          </Box>
        ))}
        {data?.paginatedList.totalPages > 1 && (
          <Box display="flex" justifyContent="flex-end">
            <Pagination
              count={data.paginatedList.totalPages}
              variant="outlined"
              shape="rounded"
              size="small"
              page={pageIndex}
              onChange={(event, page) => {
                setPageIndex(page);
              }}
            />
          </Box>
        )}
      </Box>
      {images && (
        <Box>
          <LightGallery
            elementClassNames="custom-light-gallery"
            dynamic
            dynamicEl={images}
            onInit={onInit}
            onBeforeOpen={toggleLG}
            onBeforeClose={toggleLG}
            plugins={[lgThumbnail]}
            mobileSettings={{
              controls: false,
              showCloseIcon: true,
              download: false,
            }}
            download={false}
          ></LightGallery>
        </Box>
      )}
      <Snackbar
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Alert severity="success">{t("Label.SuccessMessageReviews")}</Alert>
      </Snackbar>
      <PoweredBy
        center={data?.paginatedList.totalPages > 1}
        planId={config.planId}
        widget={messageType}
        dh={config.dh}
      />
    </Box>
  );
};
export default ProductReviews;
